import options from './map.component';

export default {
    selector: 'dtMap',
    options
};



// WEBPACK FOOTER //
// ./app/common/map/index.js